import React from 'react';
import { Lock, Zap, ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  return <section className="bg-brand-dark py-24 px-4 sm:px-6 lg:px-8 text-white relative overflow-hidden" data-id="element-26">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-gold to-transparent opacity-50" data-id="element-27"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-28">
        <div data-id="element-29">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-serif font-bold text-white mb-8 leading-tight" data-id="element-30">
            ¿Cuántos lunes más vas a empezar de cero?
          </h2>

          <div className="text-xl sm:text-2xl text-gray-300 font-serif space-y-4 mb-12 max-w-2xl mx-auto" data-id="element-31">
            <p data-id="element-32">
              Cada día que pasa con inflamación activa, tu vientre retiene más.
              Tu energía se drena más. Tu mente se nubla más.
            </p>
            <p className="text-brand-gold font-bold" data-id="element-33">
              No es drama. Es biología.
            </p>
            <p data-id="element-34">
              Y tienes la solución delante ahora mismo por menos de lo que
              cuesta un almuerzo.
            </p>
          </div>

          <div className="bg-white/5 border border-brand-gold/30 rounded-3xl p-8 sm:p-12 max-w-2xl mx-auto md:backdrop-blur-sm" data-id="element-35">
            <div className="mb-4" data-id="element-36">
              <span className="text-gray-400 text-lg" data-id="element-37">Valor del sistema: </span>
              <span className="text-gray-400 text-xl line-through decoration-brand-red decoration-2" data-id="element-38">
                205€
              </span>
            </div>

            <h3 className="text-2xl font-bold text-brand-gold mb-2 tracking-widest uppercase" data-id="element-39">
              Hora de Reiniciar
            </h3>

            <div className="mb-8 flex flex-col items-center justify-center" data-id="element-40">
              <span className="text-6xl sm:text-7xl font-bold text-white mb-2" data-id="element-41">
                26€
              </span>
              <span className="text-gray-400" data-id="element-42">
                (IVA incluido · Acceso inmediato)
              </span>
            </div>

            <a href="https://pay.hotmart.com/W104988940M?off=y9azogt4&checkoutMode=10&bid=1774913274137" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="block w-full bg-brand-gold text-brand-dark font-bold text-xl sm:text-2xl py-6 px-8 rounded-full hover:bg-yellow-500 transition-colors shadow-lg mb-8 min-h-[56px] flex items-center justify-center" data-id="element-43">
              ⚡ SÍ, QUIERO MI REINICIO BIOLÓGICO — 26€
            </a>

            <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6 text-sm text-gray-300 font-medium" data-id="element-44">
              <div className="flex items-center" data-id="element-45">
                <Lock className="w-4 h-4 mr-2 text-brand-gold" data-id="element-46" />
                <span data-id="element-47">Pago 100% seguro</span>
              </div>
              <div className="flex items-center" data-id="element-48">
                <Zap className="w-4 h-4 mr-2 text-brand-gold" data-id="element-49" />
                <span data-id="element-50">Acceso en menos de 2 minutos</span>
              </div>
              <div className="flex items-center" data-id="element-51">
                <ShieldCheck className="w-4 h-4 mr-2 text-brand-gold" data-id="element-52" />
                <span data-id="element-53">Garantía 15 días sin preguntas</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}